import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { AuthData } from '../providers/auth';

@Pipe({
  name: 'profile_networking'
})

export class ProfileNetworkingPipe implements PipeTransform {

  constructor(
    private authData: AuthData
  ) { }

  transform(userData: any, clientId: string, type: string): Observable<any> {
    if (type === 'event') {
      return this.authData.getUserDB(userData.userId, clientId).map(item => {
        if (item) {
          return item.isNetworking ? item : null
        }
        return null;
      });
    } else {
      return Observable.of(userData);
    }
  }
}


// WEBPACK FOOTER //
// ./src/pipes/profile-networking.pipe.ts